import ApiService from '@/helpers/api.service.ext';

const API = new ApiService();

const ENDPOINT = 'smart-raffle';

export const state = {
  displayLoader: true,
  errors: null
}

export const mutations = {
  SET_ERROR(state, errors){
    state.errors = errors;
  },
  UPDATE_PRELOADER(state, status){
    state.displayLoader = status;
  },
}

export const actions = {
  // {
  //   action: "action",
  //   body: {"obj":obj}
  // }
  actionSmartRaffle(context, params) {
    return new Promise((resolve, reject) => {
      context.commit('UPDATE_PRELOADER', ["live-draw-details"].includes(params.action) ? false:true);
      API.post(`/${ENDPOINT}/${params.action}`, params.body)
        .then(({ data }) => {
          if (data.status === "ok") {
            resolve(data)
          } else {
            reject(data.message)
          }
          context.commit('UPDATE_PRELOADER', true);
        })
        .catch(({ response }) => {
          context.commit('UPDATE_PRELOADER', true);
          context.commit('SET_ERROR', response.data.errors);
          reject();
        });
    });
  }
}

export const getters = {}